import { useContext } from 'react';

import { ShoppingPlannerContext } from '../Context/ShoppingPlannerContext';
import { useProductsFromStates } from './UseProductsFromStates';

export const useShoppingList = () => {
    const { wallLength, innerCorners, corners, endCaps } = useContext(ShoppingPlannerContext);

    const { decor, insulation, skirtingDecor, skirting, installationAndCare, sqm } = useProductsFromStates();

    const decorPackageAmount = decor ? Math.ceil(sqm / decor.squareMetersPerPackage) : 0;
    const decorPrice = decorPackageAmount && decor ? decorPackageAmount * decor.price : 0;

    const insulationPackageAmount = insulation ? Math.ceil(sqm / insulation.squareMetersPerPackage) : 0;
    const insulationPrice =
        insulationPackageAmount && insulation ? insulationPackageAmount * insulation.pricePerPackage : 0;

    const skirtingPackageAmount =
        skirting && wallLength ? Math.ceil((parseInt(wallLength) * 1000) / skirting?.dimensions.length) : 0;
    const skirtingPrice =
        skirting && skirtingDecor && wallLength !== '' ? skirtingPackageAmount * skirtingDecor.pricePerPiece : 0;

    const installationAndCarePrice = installationAndCare.reduce(
        (acc, product) => product.variants[0].pricePerPiece + acc,
        0
    );

    const cornersAndCaps = [
        innerCorners ? innerCorners + ' Innenecken' : undefined,
        corners ? corners + ' Außenecken' : undefined,
        endCaps ? endCaps + ' Endkappen' : undefined,
    ].filter((entry) => entry !== undefined);

    const total = decorPrice + skirtingPrice + insulationPrice + installationAndCarePrice;

    return {
        decorPackageAmount,
        decorPrice,
        skirtingPackageAmount,
        skirtingPrice,
        insulationPackageAmount,
        insulationPrice,
        cornersAndCaps,
        installationAndCarePrice,
        total,
    };
};
